import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/:id',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'beautyClinicInner' */ './component')],
			render: ([BeautyClinicInner]) => <BeautyClinicInner />,
			onEnter: async ({ next }) => {
				const children = await next();
				return children;
			},
		},
	],
};
export default routes;
